import { render, staticRenderFns } from "./CandidatAnswer404.vue?vue&type=template&id=51f45416&scoped=true"
var script = {}
import style0 from "./CandidatAnswer404.vue?vue&type=style&index=0&id=51f45416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f45416",
  null
  
)

export default component.exports